import { take, put, call, all, select } from 'redux-saga/effects';
import uuid from 'uuid/v4';
import set from 'lodash.set';

import { selectUserGroups } from 'yeself-client-common/security/SecuritySelector';

import log from 'yeself-client-common/utils/LogUtils';

import { pushNotificationToStack } from 'Console/data/notification/actions';
import { selectAccountSettings } from 'Console/data/accounts/selectors';

import {
    FETCH_ACCOUNTS,
    FETCH_ACCOUNT_SETTINGS,
    REGISTER_USER,
    FETCH_ACCOUNT_INVOICES,
    UPDATE_ACCOUNT_GENERAL_SETTINGS,
} from './constants';
import {
    fetchAccountsSuccess,
    fetchAccountsError,
    fetchAccountSettingsSuccess,
    fetchAccountSettingsError,
    registerUserSuccess,
    registerUserError,
    fetchAccountInvoicesSuccess,
    fetchAccountInvoicesError,
} from './actions';
import {
    fetchAccountsService,
    fetchAccountSettingsService,
    updateAccountSettingsService,
    registerUserService,
} from './services';

const mockedAccountInvoicesResponse = [
    {
        id: 12345,
        numberInvoices: 14053,
        billingDate: 1646726824621,
        amount: 'N/A',
        status: 'Paid',
    },
    {
        id: 12346,
        numberInvoices: 14054,
        billingDate: 1646726824621,
        amount: '2671',
        status: 'Pending',
    },
    {
        id: 12347,
        numberInvoices: 14055,
        billingDate: 1646726824622,
        amount: '2607',
        status: 'Paid',
    },
    {
        id: 12348,
        numberInvoices: 14056,
        billingDate: 1646726824623,
        amount: 'N/A',
        status: 'Pending',
    },
];

// Fetch accounts
function* fetchAccountsWatcher() {
    while (true) {
        const {
            payload: { groups },
        } = yield take(FETCH_ACCOUNTS);

        if (groups.length === 0) {
            yield put(
                pushNotificationToStack('Unable to load accounts. User does not belong to any group')
            );
        }

        try {
            const groupName = groups.length > 0 && groups[0].split('/').slice(-1)[0];

            const resp = yield call(fetchAccountsService, groupName);
            const data = JSON.parse(resp.text).payload;
            yield put(fetchAccountsSuccess(data));
        } catch (err) {
            log.error(err);
            yield put(fetchAccountsError());
        }
    }
}

// Fetch account settings
function* fetchAccountSettingsWatcher() {
    while (true) {
        const { payload } = yield take(FETCH_ACCOUNT_SETTINGS);

        try {
            const resp = yield call(fetchAccountSettingsService, payload);
            const data = JSON.parse(resp.text).payload;
            yield put(fetchAccountSettingsSuccess(data));
        } catch (err) {
            log.error(err);
            yield put(fetchAccountSettingsError());
        }
    }
}

function* updateAccountGeneralSettingsWatcher() {
    while (true) {
        const {
            payload: { accountId, data },
            message,
        } = yield take(UPDATE_ACCOUNT_GENERAL_SETTINGS);

        const accountSettings = yield select(selectAccountSettings);

        Object.keys(data).forEach((item) => {
            set(accountSettings, item, data[item]);
        });

        try {
            yield call(updateAccountSettingsService, accountId, accountSettings);
            yield put(fetchAccountSettingsSuccess(accountSettings));
            yield put(pushNotificationToStack(message.success));
        } catch (err) {
            log.error('err', err);
            yield put(fetchAccountSettingsError());
            yield put(pushNotificationToStack(message.fail));
        }
    }
}

function* registerUserWatcher() {
    while (true) {
        const { payload, message } = yield take(REGISTER_USER);
        const groups = yield select(selectUserGroups);

        try {
            const resp = yield call(registerUserService, { ...payload, groups });
            const user = JSON.parse(resp.text).payload;
            yield put(registerUserSuccess(user));
            yield put(pushNotificationToStack(message.success));
        } catch (err) {
            log.error(err);
            yield put(registerUserError());
            yield put(pushNotificationToStack(message.fail));
        }
    }
}

// Fetch Account Invoices
function* fetchAccountInvoicesWatcher() {
    while (true) {
        yield take(FETCH_ACCOUNT_INVOICES);
        try {
            // const res = yield call(fetchAccountSettingsService);
            yield put(fetchAccountInvoicesSuccess(mockedAccountInvoicesResponse));
        } catch (err) {
            log.error(err);
            yield put(fetchAccountInvoicesError());
        }
    }
}

export default function* accountsSaga() {
    yield all([
        fetchAccountsWatcher(),
        fetchAccountSettingsWatcher(),
        registerUserWatcher(),
        fetchAccountInvoicesWatcher(),
        updateAccountGeneralSettingsWatcher(),
    ]);
}
